const PREFIX = "pl-bill-collapsible-header";

export const PL_BILL_COLLAPSIBLE_HEADER_TEST_IDS = {
    TOGGLE_BUTTON: `${PREFIX}-toggle`,
    COLLAPSE_CONTENT: `${PREFIX}-content`,
    UPSELL_CHIP: `${PREFIX}-upsell-chip`,
    INFO_TEXT: `${PREFIX}-info-text`,
};
